export const environment = {
  production: false,
  BASE_PATH: 'http://localhost:8084',
  DASHBOARD_URL: 'https://dev.synection.de',
  GLOBALS: {
    DEFAULT_LOCALE: 'de',
    DEFAULT_LOCALE_ID: 'de-DE',
    DEFAULT_DATE_FORMAT: 'DD.MM.YYYY',
    DEFAULT_CURRENCY_CODE: 'EUR',
    NUMBER_CONFIGURATIONS: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  AUTH: {
    OIDC_ISSUER: 'https://dev-sso.synection.de/auth/realms/Syneco-Portal'
  }
};
